import { PropsWithChildren, ReactElement } from "react";

import { getNodeValue, selectNodesInGraph } from "../../stores/ai-context";
import { Button } from "../catalyst/Button";

export const NodeSelector = ({
  children,
  nodeId,
}: PropsWithChildren<{ nodeId: string }>): ReactElement => {
  return (
    <Button
      className="font-inherit rounded border border-blue-400/60 p-1 text-sm text-blue-400 underline decoration-blue-400 transition-all duration-200 hover:border-blue-400 hover:bg-blue-400/10"
      onClick={() => {
        void selectNodesInGraph([nodeId]);
      }}
      plain
      size="xs"
    >
      {getNodeValue(nodeId) ?? children}
    </Button>
  );
};
